// Static configuration for the Lead Finder Chrome extension install wizard.

// Served from saleshandy-webui/public/sh-lead-finder.zip.
export const LEAD_FINDER_EXTENSION_ZIP_URL = '/sh-lead-finder.zip';
export const LEAD_FINDER_EXTENSION_ZIP_NAME = 'sh-lead-finder.zip';
export const CHROME_EXTENSIONS_URL = 'chrome://extensions';

// Sample LinkedIn / Sales Navigator pages used by the Finish step to let users
// try the extension.
export const LINKEDIN_PERSON_URL = 'https://www.linkedin.com/in/dhruvikigai/';
export const LINKEDIN_COMPANY_URL =
  'https://www.linkedin.com/company/saleshandy';
export const SALES_NAVIGATOR_LEAD_PROFILE_URL =
  'https://www.linkedin.com/sales/lead/ACwAAArVxj4B27mQfxTdRXpiXUNUMSq2Tp8EMEs,NAME_SEARCH,mI69';

export const WIZARD_STEPS = [
  { step: 1, label: 'Overview' },
  { step: 2, label: 'Install' },
  { step: 3, label: 'Finish' },
] as const;

export type InstallStepAction = 'download' | 'open-chrome';

export type InstallStep = {
  title: string;
  description: string;
  action?: InstallStepAction;
};

// The four ordered installation steps. Their index maps 1:1 to a carousel slide.
export const INSTALL_STEPS: InstallStep[] = [
  {
    title: 'Download the ZIP file',
    description: 'Click the download button. It saves to your Downloads folder.',
    action: 'download',
  },
  {
    title: 'Extract the ZIP file',
    description:
      'In your Downloads, find sh-lead-finder.zip, right-click and select Extract All. Keep the folder in place.',
  },
  {
    title: 'Open Chrome extensions, turn on Developer mode',
    description:
      'Paste chrome://extensions into your address bar, then turn on the toggle (top right).',
    action: 'open-chrome',
  },
  {
    title: "Click 'Load unpacked' and pick the folder",
    description: "Top-left button. Select the extracted folder from step 2. That's it.",
  },
];

export const OVERVIEW_CARDS = [
  {
    eyebrow: 'FOR A PERSON',
    title: 'Contacts & background',
    points: [
      'Reveal verified email & phone',
      'See current role & tenure',
      'Explore skills & active experience',
    ],
  },
  {
    eyebrow: 'FOR A COMPANY',
    title: 'Enrich & get insights',
    points: [
      'One-click company enrichment',
      'Decision makers with their contacts',
      'Financial growth, tech stack & news',
    ],
  },
] as const;
